import { Component } from '@theme/component';
import { morph } from '@theme/morph';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/**
 * Little Flock value stack: compare-at price struck through, the live price, a "save" pill and a
 * launch line. Rendered by Liquid for the selected variant; on variant change it swaps its content
 * for the copy rendered in the section response that the variant picker already fetched, so the
 * numbers always come from the server and never from client-side math.
 *
 * @extends {Component}
 */
class LfPriceStack extends Component {
  #controller = new AbortController();

  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect, {
      signal: this.#controller.signal,
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller.abort();
    this.#controller = new AbortController();
  }

  /**
   * @param {ProductSelectEvent} event - The product select event.
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (detail.productId && this.dataset.productId && detail.productId !== this.dataset.productId) return;

        const next = detail.html.querySelector(`lf-price-stack[data-block-id="${this.dataset.blockId}"]`);
        if (!next) return;

        morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[lf-price-stack] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('lf-price-stack')) {
  customElements.define('lf-price-stack', LfPriceStack);
}
